module.exports = __webpack_public_path__ + "img/img-success.eceef380.png";